import { Grid } from '@mui/material';
import { PrimaryButton } from '../../theme/index'
import '../../sass/styles.scss';
import { UseScreen } from '../../hooks/UseScreen.hook';
import { useDispatch } from 'react-redux';
import { modalDeleteAction } from '../../redux/reducers/Modal';
import { deleteLevelAction } from '../../redux/reducers/Delete';

const Level = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();

  const deleteLevel = () => {
    dispatch(deleteLevelAction()); // delete from db.
    dispatch(modalDeleteAction());
  }

  return (
    <>
        <Grid item xs={ 10 }>
          {
            ( screenWidth > 500 ) ?
              <h5 style={{ margin: '0', marginBottom: '2rem' }}>Nivel / eliminar</h5>
            :
              <h6 style={{ margin: '0', marginBottom: '2rem' }}>Nivel / eliminar</h6>
          }
        </Grid>
        <Grid item xs={ 12 }textAlign='center'>
          {
            ( screenWidth > 500 ) ?
              <h3>Esta seguro que desea eliminar este nivel?</h3>
            :
              <h6>Esta seguro que desea eliminar este nivel?</h6>
          }
        </Grid>
        <Grid item xs={ 12 } sx={{ mt: 2 }} textAlign='center' className='pr-2'>
            <PrimaryButton onClick={ () => deleteLevel() } sx={{ width: '50%', boxShadow: 5 }}>Eliminar</PrimaryButton>
        </Grid>
    </>
  )
}

export default Level